import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserAuthGuard } from './auth-guards/user-guard';
import { ModeratorAuthGuard } from './auth-guards/moderator-guard';
import { NonUserAuthGuard } from './auth-guards/nonuser-guard';
import { WriterAuthGuard } from './auth-guards/writer-guard';
import { HomePageComponent } from './components/home-page/home-page.component';
import { CookbookPageComponent } from './components/recipe-related/cookbook/cookbook-page/cookbook-page.component';

const routes: Routes = [
  {
    path: 'register',
    loadComponent: () =>
      import('./components/auth/register-page/register-page.component').then(
        (m) => m.RegisterPageComponent,
      ),
    canActivate: [NonUserAuthGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/auth/login-page/login-page.component').then((m) => m.LoginPageComponent),
    canActivate: [NonUserAuthGuard],
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./components/public-facing/about-page/about-page.component').then(
        (m) => m.AboutPageComponent,
      ),
  },
  {
    path: 'settings',
    redirectTo: 'settings/profile',
  },
  {
    path: 'settings/:page',
    loadComponent: () =>
      import('./components/settings/settings-page/settings-page.component').then(
        (m) => m.SettingsPageComponent,
      ),
    canActivate: [UserAuthGuard],
  },
  {
    path: 'cookbook',
    loadComponent: () =>
      import('./components/recipe-related/cookbook/cookbook-page/cookbook-page.component').then(
        (m) => m.CookbookPageComponent,
      ),
    canActivate: [UserAuthGuard],
  },
  {
    path: 'plan',
    loadComponent: () =>
      import('./components/meal-plan-page/meal-plan-page.component').then(
        (m) => m.MealPlanPageComponent,
      ),
    canActivate: [UserAuthGuard],
  },

  {
    path: '',
    loadComponent: () =>
      import('./components/home-page/home-page.component').then((m) => m.HomePageComponent),
  },

  {
    path: 'tab/:username/:tabname',
    loadComponent: () =>
      import('./components/recipe-related/cookbook/cookbook-page/cookbook-page.component').then(
        (m) => m.CookbookPageComponent,
      ),
    canActivate: [UserAuthGuard],
  },
  {
    path: 'verify/:username',
    loadComponent: () =>
      import('./components/auth/verify-email-page/verify-email-page.component').then(
        (m) => m.VerifyEmailPageComponent,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import(
        './components/auth/forgot-password/forgot-password-request-page/forgot-password-request-page.component'
      ).then((m) => m.ForgotPasswordRequestPageComponent),
  },
  {
    path: 'reset-password/:email',
    loadComponent: () =>
      import(
        './components/auth/forgot-password/forgot-password-page/forgot-password-page.component'
      ).then((m) => m.ForgotPasswordPageComponent),
  },
  {
    path: 'view-recipe',
    loadComponent: () =>
      import(
        './components/recipe-related/viewing-components/view-recipe-page/view-recipe-page.component'
      ).then((m) => m.ViewRecipePageComponent),
  },
  {
    path: 'create-recipe',
    loadComponent: () =>
      import(
        './components/recipe-related/recipe-modification/create-recipe-component/create-recipe-component.component'
      ).then((m) => m.CreateRecipeComponentComponent),

    canActivate: [UserAuthGuard],
  },
  {
    path: 'edit-recipe',
    loadComponent: () =>
      import(
        './components/recipe-related/recipe-modification/edit-recipe-component/edit-recipe-component.component'
      ).then((m) => m.EditRecipeComponentComponent),
    canActivate: [UserAuthGuard],
  },
  {
    path: 'ingredient-management',
    loadComponent: () =>
      import('./components/management/ingredient-management/ingredient-management.component').then(
        (m) => m.IngredientManagementComponent,
      ),
    canActivate: [ModeratorAuthGuard],
  },
  {
    path: 'reports-management',
    loadComponent: () =>
      import('./components/management/reports-management/reports-management.component').then(
        (m) => m.ReportsManagementComponent,
      ),
    canActivate: [ModeratorAuthGuard],
  },
  {
    path: 'feedback',
    loadComponent: () =>
      import('./components/management/feedback-management/feedback-management.component').then(
        (m) => m.FeedbackManagementComponent,
      ),
    canActivate: [ModeratorAuthGuard],
  },
  {
    path: 'print',
    loadComponent: () =>
      import(
        './components/recipe-related/viewing-components/print-recipe/print-recipe.component'
      ).then((m) => m.PrintRecipeComponent),
  },
  {
    path: 'user-guides',
    loadComponent: () =>
      import('./components/public-facing/user-guides/user-guides.component').then(
        (m) => m.UserGuidesComponent,
      ),
  },
  {
    path: 'user-guides/:page',
    loadComponent: () =>
      import('./components/public-facing/user-guides/user-guides.component').then(
        (m) => m.UserGuidesComponent,
      ),
  },
  {
    path: 'blog/:blog',
    loadComponent: () =>
      import('./components/public-facing/blogs/blog-post-list/blog-post-list.component').then(
        (m) => m.BlogPostListComponent,
      ),
  },
  {
    path: 'blog/:blog/:id',
    loadComponent: () =>
      import('./components/public-facing/blogs/blog-post/blog-post.component').then(
        (m) => m.BlogPostComponent,
      ),
  },
  {
    path: 'edit-blog/:blog',
    loadComponent: () =>
      import('./components/public-facing/blogs/writers/create-blog/create-blog.component').then(
        (m) => m.CreateBlogComponent,
      ),
    canActivate: [WriterAuthGuard],
  },
  {
    path: 'edit-blog/:blog/:id',
    loadComponent: () =>
      import('./components/public-facing/blogs/writers/create-blog/create-blog.component').then(
        (m) => m.CreateBlogComponent,
      ),
    canActivate: [WriterAuthGuard],
  },
  // { path: 'test', component: TestPageComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
